/* eslint-disable no-param-reassign */
import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API_URL}/api`,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
  },
});

instance.interceptors.request.use((config) => {
  if (!window.navigator.onLine) {
    return Promise.reject({
      messageText: "No internet connection.",
    });
  }

  // Retrieve the socketId from sessionStorage
  const socketId = window.sessionStorage.getItem("socketId");

  // Add the socketId as a header to the request
  if (socketId) {
    config.headers["x-socket-id"] = socketId;
  }

  try {
    // Get the Auth0 access token
    const auth0AccessToken = window.localStorage.getItem("token");

    // Only add Authorization header if token exists and is valid
    if (
      auth0AccessToken &&
      auth0AccessToken !== "null" &&
      auth0AccessToken !== "undefined"
    ) {
      config.headers.Authorization = `Bearer ${auth0AccessToken}`;
    } else if (process.env.NODE_ENV === "development") {
      console.warn(
        "[axios] No valid token found in localStorage for request:",
        config.url
      );
    }
  } catch (error) {
    console.error("[axios] Error retrieving token:", error);
    Cookies.remove("role");
    localStorage.clear();
    window.location.href = "/login";
  }

  return config;
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";
    const suppress403Redirect =
      Boolean(error?.config?.params?.suppress403Redirect) ||
      Boolean(error?.config?.headers?.["x-suppress-403-redirect"]);

    const isComplianceEndpoint = requestUrl.includes("/compliance");

    if (status === 403 && !isComplianceEndpoint && !suppress403Redirect) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          "[axios] 403 Forbidden on non-compliance endpoint, redirecting to /access-denied:",
          requestUrl
        );
      }
      window.location.href = "/access-denied";
    } else if (
      status === 403 &&
      (isComplianceEndpoint || suppress403Redirect)
    ) {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "[axios] 403 Forbidden suppressed for endpoint:",
          requestUrl
        );
      }
    }

    if (status === 401) {
      if (process.env.NODE_ENV === "development") {
        console.warn("[axios] 401 Unauthorized, redirecting to /login");
      }
      Cookies.remove("role");
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error?.response?.data ?? error);
  }
);

export default instance;
